import { RemoteGetSemesterById } from 'data/usecases';
import { makeApiUrlEntitiesSemesters } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetSemesterById = (): RemoteGetSemesterById => {
  return new RemoteGetSemesterById(
    makeApiUrlEntitiesSemesters(),
    makeAxiosHttpClient(),
  );
};
